import {
  ACTIVATE_AUTH_LAYOUT,
  ACTIVATE_NON_AUTH_LAYOUT,
  TOGGLE,
} from "./actionTypes";

export const initialState = {
  topbar: true,
  sidebar: true,
  footer: true,
  layoutType: "Auth",
  is_toggle: true,
};

const layout = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVATE_AUTH_LAYOUT:
      state = {
        ...state,
        ...action.payload,
      };
      break;
    case ACTIVATE_NON_AUTH_LAYOUT:
      state = {
        ...state,
        ...action.payload,
      };
      break;

    case TOGGLE:
      state = {
        ...state,
        is_toggle: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default layout;
